/* eslint-disable no-unused-expressions */

import React from "react";
import { gql } from "@apollo/client";

import Link from "next/link";
import CustomCarousel from "components/Feedblocks/CustomCarousel.js";

import { makeStyles } from "tss-react/mui";

import Card from "components/Card/Card";
import CardBody from "components/Card/CardBody";
import Muted from "components/Typography/Muted";

import { getAuthorisedImage } from "modules/utils";

import LocationOnIcon from "@mui/icons-material/LocationOn";

import {
  ATHLETES_ID,
  SHOW_STRAVA_LOGIN,
  DENSE_RESPONSIVE_SETTINGS,
} from "settings/global-website-config";

import { LinkableAvatar } from "./ProductAthletesAvatarGroup";

import {
  mlAuto,
  mrAuto,
  boxShadowMinimal,
} from "../../assets/jss/nextjs-material-kit-pro";

const useStyles = makeStyles()({
  avatarLarge: {
    height: "88px",
    width: "88px",
    ...mlAuto,
    ...mrAuto,
    ...boxShadowMinimal,
  },
  nameTitle: {
    "&, & a": {
      fontSize: "14px",
      marginTop: "0", // '.625rem',
      marginBottom: "0", // '.025rem',
      minHeight: "auto",
    },
  },

  cardBodyContainer: {
    padding: "0.9375rem 0.47rem",
    display: "inline-block",
    verticalAlign: "top",
    marginTop: "0px",
    "& h6": {
      margin: "0px",
      lineHeight: "20px",
    },
    "& svg": {
      verticalAlign: "middle",
      fontSize: "1rem",
    },
  },
});

// *** Displays up to 3 videos side by side on fullscreen width ***

// NB currently only supports YouTube but can be changed by altering the import at the top of this file

export function ProductAthletes(props) {
  const { athletes, showCountry } = props;
  const { classes } = useStyles();

  return (
    <div id={ATHLETES_ID}>
      <CustomCarousel responsiveSettings={DENSE_RESPONSIVE_SETTINGS}>
        {athletes.map((athlete) => {
          const athleteProps = {
            // variant: 'rounded',// Prefer circle
            src: getAuthorisedImage(athlete),
            unoptimized: athlete.node.integration.accountAuthorised, // Images pulled direct from Strava have unpredictable pathnames so it's hard to guarantee we've correctly whitelisted them all. So for now we do not optimise these
            alt: athlete.node.name,
            className: classes.avatarLarge,
          };
          if (SHOW_STRAVA_LOGIN) {
            athleteProps.href = athlete.node.uri;
          }
          return (
            <React.Fragment key={athlete.node.name}>
              {/* <SocialProfileJsonLd
              type="Person"
              name={athlete.node.name}
              url={ROOT_URL}
              sameAs={[
                `${athlete.node.integration.integrationPlatform.integrationDetails.profileUrl}${athlete.node.integration.platformId}`,
              ]}
            /> */}
              <Card profile plain noMargin>
                <LinkableAvatar {...athleteProps} />
                <CardBody className={classes.cardBodyContainer}>
                  <h4 className={classes.nameTitle}>
                    <Link
                      prefetch={false}
                      href={athlete.node.uri}
                      legacyBehavior
                    >
                      {athlete.node.name}
                    </Link>
                  </h4>

                  {showCountry && (
                    <div>
                      <Muted>
                        <h6 className={classes.shrinkIcons}>
                          <LocationOnIcon fontSize="small" />
                          {athlete.node.athleteDetails.country?.name}
                        </h6>
                      </Muted>
                      {/* <Button
                      link
                      component="a"
                      href={`${athlete.node.integration.integrationPlatform.integrationDetails.profileUrl}${athlete.node.integration.platformId}`}
                      target="_blank"
                      classes={{
                        root: classes.viewOnPlatform,
                        startIcon: classes.smallIcon,
                      }}
                      size="small"
                      startIcon={
                        <SocialIcon
                          channel={
                            athlete.node.integration.integrationPlatform.slug
                          }
                        />
                      }
                    /> */}
                    </div>
                  )}

                  {/* {athlete.node.athleteDetails.specialities &&
                    athlete.node.athleteDetails.specialities.length > 0 && (
                      <div>
                        <Muted>
                          <h6>
                            <DirectionsRunIcon fontSize="small" />
                            {athlete.node.specialities.map((speciality) => (
                              <React.Fragment key={speciality.uri}>
                                <Link href={speciality.uri} passHref>
                                  {speciality.name}
                                </Link>{' '}
                              </React.Fragment>
                            ))}
                          </h6>
                        </Muted>
                      </div>
                    )} */}
                </CardBody>
              </Card>
            </React.Fragment>
          );
        })}
      </CustomCarousel>
    </div>
  );
}

export const PRODUCTATHLETEFRAGMENT = gql`
  fragment ProductAthleteFragment on Athlete {
    id
    name
    uri
    ...FeaturedImageThumbnailFragment
    integration {
      platformId
      accountAuthorised
      integrationPlatform {
        ... on Integration {
          id
          slug
          title
          slug
          integrationDetails {
            profileUrl
          }
        }
      }
    }
    athleteDetails {
      followerCount
      city {
        id
        name
        slug
      }
      state {
        id
        name
        slug
      }
      country {
        id
        name
        slug
      }
      sports {
        id
        name
        slug
      }
      profileImages {
        profile
        profileMedium
      }
      specialities {
        event {
          id
          slug
          name
          uri
        }
        terrain {
          id
          slug
          name
          uri
        }
      }
    }
  }
`;

export const ATHLETE_FRAGMENT = gql`
  fragment AthleteFragment on Athlete {
    id
    name
    uri
    featuredImage {
      node {
        thumbnail: sourceUrl(size: THUMBNAIL)
        id
      }
    }
    athleteDetails {
      profileImages {
        profile
      }
    }
    integration {
      accountAuthorised
    }
    ...FeaturedImageThumbnailFragment
  }
`;

export const PRODUCTATHLETESFEEDFRAGMENT = gql`
  fragment ProductAthletesFeedFragment on ProductNode {
    productAthletes(where: { athleteType: PRO }, first: 12) {
      pageInfo {
        offsetPagination {
          total
        }
        hasNextPage
      }
      edges {
        node {
          ...AthleteFragment
        }
      }
    }
  }
  ${ATHLETE_FRAGMENT}
`;
